import type { IconSvgObject } from './types';

const GreaterThanOrEqualIcon: IconSvgObject = [
  ["path", { d: "M19 15L5 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 4.5L15.1461 7.58595C17.7154 8.3674 19 8.75812 19 9.5C19 10.2419 17.7154 10.6326 15.1461 11.414L5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GreaterThanOrEqualIcon;
